import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Log } from '../models/Log';
import { environment as ENV } from '../../environments/environment';
import { Utils } from '../core/Utils';

/**
 * Log service
 */
@Injectable({ providedIn: "root" })
export class LogService {
    constructor(private http: HttpClient) { }

    private readonly apiUrl = `${ENV.apiUrl}/log`;

    get(options?: {
        date?: Date,
        timeFrom?: string,
        timeTo?: string,
        level?: string,
        requestMethod?: string,
        search?: string
    }): Observable<Log[]> {
        if (!options)
            options = {};

        if (!options.date)
            options.date = new Date();

        return this.http.get<Log[]>(this.apiUrl, {
            params: {
                ...options,
                date: Utils.getInputDateString(options.date)
            }
        });
    }

    logError(error: string): Observable<any> {
        if ((error || '').replace(/\s/g, '')) {
            return;
        }

        if (error.length > 4000) {
            error = error.substring(0, 4000);
        }

        return this.http.post(this.apiUrl, {
            level: 'error',
            content: error
        });
    }
}
